import { render, staticRenderFns } from "./ActivityConfigListPage.vue?vue&type=template&id=b9249700&scoped=true"
import script from "./ActivityConfigListPage.vue?vue&type=script&lang=js"
export * from "./ActivityConfigListPage.vue?vue&type=script&lang=js"
import style0 from "./ActivityConfigListPage.vue?vue&type=style&index=0&id=b9249700&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9249700",
  null
  
)

export default component.exports